import React from "react";
import classNames from "classnames";
import useAppModernisation from "../../hooks/useAppModernisation";
import { useNavigate } from "react-router-dom";
import style from "./GuidelineChip.module.scss";
import icons from "../../scss/guidelineicons.module.scss";

const GuidelineChip = ({ iconClassSuffix, linkText, onClickProps, showArrowIcon = true, squareIcon = false }) => {
  const { isAppMode } = useAppModernisation();
  const navigate = useNavigate();

  const appGuidelineNavigation = (guideline) => {
    const normalizeGuideline = guideline.replaceAll(" ", "_");
    navigate(`/app/nav/${normalizeGuideline}`);
  };

  const webGuidelineNavigation = (guideline) => {
    const normalizeGuideline = guideline.replaceAll(" ", "_");
    navigate(`/guidelines/${normalizeGuideline}`);
  };

  if (linkText == "Drug use in pregnancy and breastfeeding") {
    linkText = "Pregnancy and breastfeeding"
  }

  return (
    <span className={style.guidelineChip}
      role="button"
      aria-label={`${linkText}-breadcrumb`}>
      <span className={classNames(icons[iconClassSuffix], style.guidelineIcon)} />
      <a
        className={classNames("size-14")}
        aria-label={linkText}
        onClick={() => {
          isAppMode
            ? appGuidelineNavigation(onClickProps)
            : webGuidelineNavigation(onClickProps);
        }}
      >
        {linkText}
        {showArrowIcon && <span className="goto-arrow">
          <i className="fa banner-head-topic fa-angle-right" />
        </span>}
      </a>
    </span>
  );
}

export default GuidelineChip;